import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TopicContentService } from 'app/shared/services/topic-content.service';

@Component({
  selector: 'app-topic-content',
  templateUrl: './topic-content.component.html',
  styleUrls: ['./topic-content.component.scss'],
  providers: [TopicContentService, DecimalPipe]
})
export class TopicContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
